/* ═══════════════════════════════════════════════════════
   CRYSTAL DRAGON COLLECTIVE — Theme JS
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── Sticky Header ── */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (currentScroll > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ── Mobile Menu ── */
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.header-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('active');
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });

    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        menuToggle.classList.remove('active');
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Ambient Stars ── */
  const ambientBg = document.querySelector('.ambient-bg');
  if (ambientBg) {
    for (let i = 0; i < 25; i++) {
      const star = document.createElement('div');
      star.className = 'ambient-star';
      star.style.top = Math.random() * 100 + '%';
      star.style.left = Math.random() * 100 + '%';
      star.style.animationDelay = Math.random() * 5 + 's';
      star.style.animationDuration = (2 + Math.random() * 4) + 's';
      const size = 1 + Math.random() * 2;
      star.style.width = size + 'px';
      star.style.height = size + 'px';
      ambientBg.appendChild(star);
    }
  }

  /* ── Scroll Reveal Animation ── */
  const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -40px 0px' };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in-up');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('[data-animate]').forEach(el => {
    el.style.opacity = '0';
    observer.observe(el);
  });

  /* ── Product Image Gallery ── */
  const galleryMain = document.querySelector('.product-gallery__main img');
  const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');
  if (galleryMain && galleryThumbs.length) {
    galleryThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.querySelector('img')?.getAttribute('data-full-src') ||
                       thumb.querySelector('img')?.src;
        if (newSrc) {
          galleryMain.src = newSrc;
          galleryThumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        }
      });
    });
  }

  /* ── Quantity Selector ── */
  document.querySelectorAll('.product-form__quantity').forEach(wrapper => {
    const input = wrapper.querySelector('input');
    const minus = wrapper.querySelector('[data-qty="minus"]');
    const plus = wrapper.querySelector('[data-qty="plus"]');
    if (input && minus && plus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
      plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* ── Variant Selector ── */
  document.querySelectorAll('.product-form__variant').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.product-form__variants').querySelectorAll('.product-form__variant').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

})();
